import { createFileRoute, redirect } from "@tanstack/react-router";

/** Legacy route: /new moved to /templates. */
export const Route = createFileRoute("/_app/new/")({
    beforeLoad: ({ location }) => {
        throw redirect({ href: `/templates${location.searchStr ?? ""}`, replace: true });
    },
});
